import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { invoiceService } from '../services/invoice.service'; // supposition du chemin

// Async thunks
export const fetchInvoices = createAsyncThunk(
  'invoice/fetchInvoices',
  async (_, { rejectWithValue }) => {
    try {
      const response = await invoiceService.getAllInvoices();
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erreur lors de la récupération des factures');
    }
  }
);

export const fetchInvoiceById = createAsyncThunk(
  'invoice/fetchInvoiceById',
  async (id, { rejectWithValue }) => {
    try {
      return await invoiceService.getInvoiceById(id);
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erreur lors de la récupération de la facture');
    }
  }
);

export const createInvoice = createAsyncThunk(
  'invoice/createInvoice',
  async (invoice, { rejectWithValue }) => {
    try {
      const result = await invoiceService.createInvoice(invoice);
      return result;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erreur lors de la création de la facture');
    }
  }
);

export const updateInvoice = createAsyncThunk(
  'invoice/updateInvoice',
  async ({ id, invoiceData }, { rejectWithValue }) => {
    try {
      const result = await invoiceService.updateInvoice(id, invoiceData);
      return result;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erreur lors de la mise à jour de la facture');
    }
  }
);

export const createAvoirFromInvoiceThunk = createAsyncThunk(
  'invoice/createAvoirFromInvoice',
  async ({ originalInvoiceId, avoirReason }, { rejectWithValue }) => {
    try {
      return await invoiceService.createAvoirFromInvoice({ originalInvoiceId, avoirReason });
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Erreur lors de la création de l'avoir"
      );
    }
  }
);

export const createPassengerCashInvoiceThunk = createAsyncThunk(
  'invoice/createPassengerCashInvoice',
  async (payload, { rejectWithValue }) => {
    try {
      const response = await invoiceService.createPassengerCashInvoice(payload);
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message ||
        error?.response?.data ||
        error?.message ||
        "Erreur lors de la génération de la facture espèce."
      );
    }
  }
);

export const softDeleteInvoice = createAsyncThunk(
  'invoice/softDeleteInvoice',
  async (id, { rejectWithValue }) => {
    try {
      await invoiceService.softDeleteInvoice(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erreur lors de la suppression de la facture');
    }
  }
);

export const hardDeleteInvoice = createAsyncThunk(
  'invoice/hardDeleteInvoice',
  async (id, { rejectWithValue }) => {
    try {
      await invoiceService.hardDeleteInvoice(id);
      return id;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erreur lors de la suppression définitive de la facture');
    }
  }
);

export const fetchActiveInvoices = createAsyncThunk(
  'invoice/fetchActiveInvoices',
  async (_, { rejectWithValue }) => {
    try {
      return await invoiceService.getActiveInvoices();
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erreur lors de la récupération des factures actives');
    }
  }
);

export const fetchInactiveInvoices = createAsyncThunk(
  'invoice/fetchInactiveInvoices',
  async (_, { rejectWithValue }) => {
    try {
      return await invoiceService.getInactiveInvoices();
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erreur lors de la récupération des factures inactives');
    }
  }
);

export const fetchInvoicesByCustomerId = createAsyncThunk(
  'invoice/fetchInvoicesByCustomerId',
  async (customerId, { rejectWithValue }) => {
    try {
      return await invoiceService.getInvoicesByCustomerId(customerId);
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erreur lors de la récupération des factures du client');
    }
  }
);

export const fetchInvoicesByCustomerName = createAsyncThunk(
  'invoice/fetchInvoicesByCustomerName',
  async (name, { rejectWithValue }) => {
    try {
      return await invoiceService.getInvoicesByCustomerName(name);
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erreur lors de la récupération des factures par nom client');
    }
  }
);

export const fetchInvoicesByDateRange = createAsyncThunk(
  'invoice/fetchInvoicesByDateRange',
  async ({ startDate, endDate }, { rejectWithValue }) => {
    try {
      return await invoiceService.getInvoicesByDateRange(startDate, endDate);
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erreur lors de la récupération des factures par date');
    }
  }
);

export const fetchInvoicesPaginated = createAsyncThunk(
  'invoice/fetchInvoicesPaginated',
  async (filter, { rejectWithValue }) => {
    try {
      return await invoiceService.getInvoicesPaginated(filter);
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Erreur lors de la récupération paginée des factures');
    }
  }
);

export const createEndOfDayPassengerInvoicesThunk = createAsyncThunk(
  'invoice/createEndOfDayPassengerInvoices',
  async ({ shopId, businessDate }, { rejectWithValue }) => {
    try {
      return await invoiceService.createEndOfDayPassengerInvoices({ shopId, businessDate });
    } catch (error) {
      return rejectWithValue(
        error.response?.data || 'Erreur lors de la création des factures TPE / Chèque'
      );
    }
  }
);

export const fetchPassengerCashSummaryThunk = createAsyncThunk(
  'invoice/fetchPassengerCashSummary',
  async ({ shopId, businessDate }, { rejectWithValue }) => {
    try {
      return await invoiceService.getPassengerCashSummary({
        shopId,
        businessDate,
      });
    } catch (error) {
      return rejectWithValue(
        error.response?.data || 'Erreur lors du chargement du résumé espèce'
      );
    }
  }
);



export const settleFiscalStampThunk = createAsyncThunk(
  'invoice/settleFiscalStamp',
  async ({ invoiceId, cashPaymentMethodId }, { dispatch, rejectWithValue }) => {
    try {
      const invoice = await dispatch(fetchInvoiceById(invoiceId)).unwrap();

      const newPayment = {
        paymentMethodId: cashPaymentMethodId, // GUID string
        paymentAmountIncludingTax: 1,
        paymentDate: new Date().toISOString(),
        paymentNotice: 'Solde du timbre fiscal',
      };

      const updatedInvoice = await dispatch(
        updateInvoice({
          id: invoiceId,
          invoiceData: {
            ...invoice,
            payments: [...(invoice.payments || []), newPayment],
          },
        })
      ).unwrap();

      return updatedInvoice;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data || error || 'Erreur lors du solde du timbre fiscal'
      );
    }
  }
);

// Initial state
const initialState = {
  invoices: [],
  totalCount: 0,
  selectedInvoice: null,
  loading: false,
  error: null,
  showModal: false,
  showDeleteModal: false,
  searchQuery: '',
  searchResults: [],
  searchLoading: false,
  filters: {
    reference: '',
    customerId: null,
    statusId: null,
    invoiceDateRange: [null, null], // on stockera des ISO strings
  },
};

// Slice
const invoiceSlice = createSlice({
  name: 'invoice',
  initialState,
  reducers: {
    openModal: (state) => {
      state.showModal = true;
    },
    closeModal: (state) => {
      state.showModal = false;
    },
    openDeleteModal: (state) => {
      state.showDeleteModal = true;
    },
    closeDeleteModal: (state) => {
      state.showDeleteModal = false;
    },
    clearError: (state) => {
      state.error = null;
    },
    setSelectedInvoice: (state, action) => {
      state.selectedInvoice = action.payload;
    },
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },
    clearSearchResults: (state) => {
      state.searchResults = [];
      state.searchQuery = '';
    },
    setInvoiceFilters: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
    },
    resetInvoiceFilters: (state) => {
      state.filters = {
        reference: '',
        customerId: null,
        statusId: null,
        invoiceDateRange: [null, null],
      };
    },

  },
  extraReducers: (builder) => {
    builder
      // Fetch all invoices
      .addCase(fetchInvoices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInvoices.fulfilled, (state, action) => {
        state.loading = false;
        state.invoices = Array.isArray(action.payload) ? action.payload : (action.payload?.items || []);
        state.totalCount = action.payload?.totalCount || (Array.isArray(action.payload) ? action.payload.length : 0);
      })
      .addCase(fetchInvoices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch invoice by ID
      .addCase(fetchInvoiceById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInvoiceById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedInvoice = action.payload;
      })
      .addCase(fetchInvoiceById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Create invoice
      .addCase(createInvoice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createInvoice.fulfilled, (state, action) => {
        state.loading = false;
        state.invoices.push(action.payload);
        state.totalCount += 1;
        state.showModal = false;
      })
      .addCase(createInvoice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Update invoice
      .addCase(updateInvoice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateInvoice.fulfilled, (state, action) => {
        state.loading = false;
        state.invoices = state.invoices.map((invoice) => {
          if (invoice.invoiceId === action.payload.invoiceId) return action.payload;
          return invoice;
        });
        state.showModal = false;
      })
      .addCase(updateInvoice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Soft delete invoice
      .addCase(softDeleteInvoice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(softDeleteInvoice.fulfilled, (state, action) => {
        state.loading = false;
        state.invoices = state.invoices.filter((invoice) => invoice.invoiceId !== action.payload);
        state.totalCount -= 1;
        state.showDeleteModal = false;
      })
      .addCase(softDeleteInvoice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Hard delete invoice
      .addCase(hardDeleteInvoice.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(hardDeleteInvoice.fulfilled, (state, action) => {
        state.loading = false;
        state.invoices = state.invoices.filter((invoice) => invoice.invoiceId !== action.payload);
        state.totalCount -= 1;
        state.showDeleteModal = false;
      })
      .addCase(hardDeleteInvoice.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch active invoices
      .addCase(fetchActiveInvoices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchActiveInvoices.fulfilled, (state, action) => {
        state.loading = false;
        state.invoices = Array.isArray(action.payload) ? action.payload : (action.payload?.items || []);
        state.totalCount = action.payload?.totalCount || (Array.isArray(action.payload) ? action.payload.length : 0);
      })
      .addCase(fetchActiveInvoices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch inactive invoices
      .addCase(fetchInactiveInvoices.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInactiveInvoices.fulfilled, (state, action) => {
        state.loading = false;
        state.invoices = Array.isArray(action.payload) ? action.payload : (action.payload?.items || []);
        state.totalCount = action.payload?.totalCount || (Array.isArray(action.payload) ? action.payload.length : 0);
      })
      .addCase(fetchInactiveInvoices.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch invoices by customer ID
      .addCase(fetchInvoicesByCustomerId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInvoicesByCustomerId.fulfilled, (state, action) => {
        state.loading = false;
        state.invoices = Array.isArray(action.payload) ? action.payload : (action.payload?.items || []);
        state.totalCount = action.payload?.totalCount || (Array.isArray(action.payload) ? action.payload.length : 0);
      })
      .addCase(fetchInvoicesByCustomerId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch invoices by customer name
      .addCase(fetchInvoicesByCustomerName.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInvoicesByCustomerName.fulfilled, (state, action) => {
        state.loading = false;
        state.invoices = Array.isArray(action.payload) ? action.payload : (action.payload?.items || []);
        state.totalCount = action.payload?.totalCount || (Array.isArray(action.payload) ? action.payload.length : 0);
      })
      .addCase(fetchInvoicesByCustomerName.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch invoices by date range
      .addCase(fetchInvoicesByDateRange.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInvoicesByDateRange.fulfilled, (state, action) => {
        state.loading = false;
        state.invoices = Array.isArray(action.payload) ? action.payload : (action.payload?.items || []);
        state.totalCount = action.payload?.totalCount || (Array.isArray(action.payload) ? action.payload.length : 0);
      })
      .addCase(fetchInvoicesByDateRange.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Fetch invoices paginated
      .addCase(fetchInvoicesPaginated.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchInvoicesPaginated.fulfilled, (state, action) => {
        state.loading = false;
        state.invoices = action.payload.items || [];
        state.totalCount = action.payload.totalCount || 0;
      })
      .addCase(fetchInvoicesPaginated.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createEndOfDayPassengerInvoicesThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createEndOfDayPassengerInvoicesThunk.fulfilled, (state, action) => {
        state.loading = false;
        const createdInvoices = Array.isArray(action.payload)
          ? action.payload
          : (action.payload?.items || action.payload?.Items || []);
        state.invoices = [...createdInvoices, ...state.invoices];
        state.totalCount += createdInvoices.length;
      })
      .addCase(createEndOfDayPassengerInvoicesThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(settleFiscalStampThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(settleFiscalStampThunk.fulfilled, (state, action) => {
        state.loading = false;

        state.invoices = state.invoices.map((invoice) => {
          if (invoice.invoiceId === action.payload.invoiceId) return action.payload;
          return invoice;
        });

        if (state.selectedInvoice?.invoiceId === action.payload.invoiceId) {
          state.selectedInvoice = action.payload;
        }
      })
      .addCase(settleFiscalStampThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(createAvoirFromInvoiceThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createAvoirFromInvoiceThunk.fulfilled, (state, action) => {
        state.loading = false;

        const createdAvoir = action.payload;

        state.invoices = [createdAvoir, ...state.invoices];
        state.totalCount += 1;
        state.selectedInvoice = createdAvoir;
      })
      .addCase(createAvoirFromInvoiceThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(createPassengerCashInvoiceThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createPassengerCashInvoiceThunk.fulfilled, (state, action) => {
        state.loading = false;

        const createdInvoice = action.payload;
        state.invoices = [createdInvoice, ...state.invoices];
        state.totalCount += 1;
        state.selectedInvoice = createdInvoice;
      })
      .addCase(createPassengerCashInvoiceThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      ;
  },
});

export const {
  openModal,
  closeModal,
  openDeleteModal,
  closeDeleteModal,
  clearError,
  setSelectedInvoice,
  setSearchQuery,
  clearSearchResults,
  setInvoiceFilters,
  resetInvoiceFilters,
} = invoiceSlice.actions;

export default invoiceSlice.reducer;
